<template>
  <div class="relative inline-block h-14 w-20 text-left lg:w-28">
    <div class="flex size-full items-center justify-start px-4 lg:px-6">
      <button
        type="button"
        class="inline-flex items-center justify-center gap-x-2.5 pl-3 text-xs font-bold leading-none text-slate-600 lg:w-8 lg:text-base"
        @click="changeOpen"
      >
        <span class="mt-[1px] uppercase">{{ locale }}</span>
        <img src="~assets/svg/icon_arrow_down.svg" alt="arrow down" class="h-4 w-4" />
      </button>
    </div>
    <div
      v-if="open"
      class="absolute right-1 -mt-2 flex w-16 flex-col items-center rounded-xl border border-slate-300 bg-white py-2.5 shadow lg:right-4 lg:w-24"
    >
      <button
        v-for="lang in languages"
        :key="lang"
        :class="['inline-flex items-center justify-center self-stretch p-2.5', {'bg-slate-100': locale === lang}]"
        @click="changeLocale(lang)"
      >
        <span class="text-xs font-bold uppercase leading-none text-slate-600 lg:text-base">
          {{ lang }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
const languages = ['ko', 'en']
const {locale, setLocale} = useI18n()
const open = ref(false)

const changeOpen = () => {
  open.value = !open.value
}

const changeLocale = lang => {
  setLocale(lang)
  applyLanguageClass(lang)
  changeOpen()
}

/** 언어별 글꼴 스타일 적용하는 함수 */
const applyLanguageClass = lang => {
  document.documentElement.classList.remove('lang-ko', 'lang-en')
  document.documentElement.classList.add(`lang-${lang}`)
  document.documentElement.setAttribute('lang', lang)
}

onMounted(() => {
  applyLanguageClass(locale.value)
})
</script>
